import { find, get } from 'lodash';
import { generateUnitTextV2 } from '@app/shared/utils/common-utils';

import { PdfFieldBuilder, PdfContent } from '../pdf.type';
import { checkboxContent, selectedCheckboxContent } from '../check-box-content';
import { MEASURE_TRANSACTION } from '@app/shared/types';

const checkBoxMeasureBuilder: PdfFieldBuilder = (
  _,
  valueParams,
): PdfContent => ({
  rowSpan: 1,
  columns: [
    get(valueParams.rowData, 'isSelectedMeasure', false)
      ? selectedCheckboxContent()
      : checkboxContent(),
    <PdfContent>{
      width: '*',
      text: generateUnitTextV2(
        find(valueParams.rowData.measures, {
          entity_id: valueParams.rowData.measure_entity_id,
        }),
        {
          numberFormatService:
            valueParams?.tools?.services?.numberFormatService,
          measureTransactionType: MEASURE_TRANSACTION.Transfer,
        },
      ),
    },
  ],
});

export { checkBoxMeasureBuilder };
